'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * get length of array|string|number.
 * @param obj
 * @returns {boolean}
 */
var getLength = exports.getLength = function getLength(obj) {
  var length = false;
  if (isNaN(obj) && obj.length !== undefined) {
    // check array length.
    if (obj.length !== undefined || typeof obj === 'string') {
      length = obj.length;
    }
  } else {
    length = obj;
  }
  return length;
};